import {Button, Popup, Skeleton, Badge} from '../polaris.jsx';
import { useState, useEffect, useContext } from 'react';
import {getUser} from "../http/getUser.jsx"
import {LoginUserPassword} from "../http/login.jsx"
import { UserContext } from '../providers/UserContext';

export function Login({ popup, setPopup, setService }) {
  const { contextloading, darkMode, theme } = useContext(UserContext);
  const [loading,setLoading] = useState(false);
  const [success, setSuccess] = useState(null); // register
  const [message,setMessage] = useState(null)
  /**
   * register form  
   * **/
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    website: window.location.href,
  });
  
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    setLoading(true)
    e.preventDefault();
    setSuccess(null)
    setMessage('')
    try {
      const response = await fetch('https://api.turbosify.com/api/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Nếu Laravel dùng Sanctum hoặc cần CSRF thì thêm headers/cookie xử lý
        },
        body: JSON.stringify(form),
      });
      const data = await response.json();
      console.warn(data)
      if (response.ok) {
        setSuccess(true)
        setMessage(data.message)
      } else {
        setSuccess("false")
        setMessage(data.error)
      }
    } catch (err) {
      setSuccess("false")
      setMessage('Đăng kí không thành công.')
    }
    setLoading(false)
  };
  /**
   * register form  
   * **/

  /**
   * login 
   * **/
  const [login, setLogin] = useState({
      login: '',
      password: ''
    });
    const handleChangeLogin = (e) => {
      setLogin({
        ...login,
        [e.target.name]: e.target.value,
      });
    };
    const { refetchUser } = useContext(UserContext); // ⬅️ thêm dòng này

    const handleLogin = async (e) => {
      setLoading(true)
      e.preventDefault();
      setSuccess(null);
      setMessage('');

      const { ok, data } = await LoginUserPassword(login);

      if (ok) {
        localStorage.setItem('session', data.session);
        setSuccess(true);
        setMessage(data.message);
        setPopup(false);
        setService(data.service);
        await refetchUser(); // ⬅️ CHÌA KHÓA: báo Provider fetch lại user!
      } else {
        setSuccess(false);
        setMessage(data.error || 'Đăng nhập thất bại.');
      }
      setLoading(false)
    };

  /**
   * login 
   * **/
  return <>
    <Popup status={popup} backgroundColor={theme.backgroundHeavy}>
      {contextloading === true ? <div className='max-w-xl mx-auto rounded-xl p-6' style={{
        backgroundColor: theme.backgroundLight,
        color: theme.textColor
      }}><Skeleton/></div> : 
      <>
      <div className='max-w-xl mx-auto rounded-xl border border-purple-500'>
        <div className='relative p-6'>
        {/* <h2 className="text-lg font-semibold mb-4">Đăng kí</h2> */}
        <p className='absolute top-[10px] right-[10px] text-xs cursor-pointer' onClick={() => setPopup(false)}>Tắt</p>
        <p className="mb-4">Ooppss, hình như bạn chưa đăng nhập.</p>
        <form className='space-y-2 mb-2'>
          <input
              type="text"
              placeholder="Email/ số điện thoại"
              name="login"
              onChange={handleChangeLogin}
              className="w-full text-white p-2 rounded-lg" style={{ backgroundColor: theme.backgroundLight}}
            />
          <input
              type="password"
              placeholder="******"
              name="password"
              onChange={handleChangeLogin}
              className="w-full text-white p-2 rounded-lg"
              style={{ backgroundColor: theme.backgroundLight}}
            />
          <Button click={handleLogin} disabled={loading}>
            {loading ? 'Đang đăng nhập ...' : 'Đăng nhập'}
          </Button>
          </form>
        </div>
      </div>

      <div className="h-[30px]"/>

      <div className='max-w-xl mx-auto rounded-xl border border-purple-500'>
        <div className='relative p-6'>
        {/* <h2 className="text-lg font-semibold mb-4">Đăng kí</h2> */}
          
        <p className="mb-4">Hoặc đăng kí trước khi sử dụng</p>

          <form onSubmit={handleSubmit} className='space-y-2 mb-2'>
          <input
            type="text"
            placeholder="Tên"
            name="name"
            className="w-full text-white p-2 rounded-lg"
            style={{ backgroundColor: theme.backgroundLight}}
            onChange={handleChange}
          />
          <input
            type="text"
            placeholder="email"
            name="email"
            className="w-full text-white p-2 rounded-lg"
              style={{ backgroundColor: theme.backgroundLight}}
            onChange={handleChange}
          />
          <input
            type="text"
            placeholder="số điện thoại"
            name="phone"
            className="w-full text-white p-2 rounded-lg"
              style={{ backgroundColor: theme.backgroundLight}}
            onChange={handleChange}
          />
          <input
            type="password"
            placeholder="mật khẩu"
            name="password"
            className="w-full text-white p-2 rounded-lg"
              style={{ backgroundColor: theme.backgroundLight}}
            onChange={handleChange}
          />
          </form>
          <Button click={handleSubmit} disabled={loading}>
            Đăng ký
          </Button>

        </div>
      </div>

      <div className='h-[30px]'/>
      {success ? <>
      <div className='max-w-xl mx-auto rounded-xl p-3 flex'>
        <div className="mx-auto">
        {success == "false" ? <>
          <Badge><p className="text-black">{message}</p></Badge>
        </> : <>
          <Badge status="success"><p className="text-black">{message}</p></Badge>
        </>}
        </div>
      </div>
      </> : null }
        </>  }
    </Popup>
</>
}

export function Dashboard({ dashboard, setDashboard, setPopup, setService}) {
  const { darkMode, theme } = useContext(UserContext);
  const [user, setUser] = useState(null);
  const token = localStorage.getItem('session');
  const getUserInformation = async () => {
    const res = await getUser(token);
    // console.warn(res)
    if (res !== false) { 
      setUser(res); setService(res.service);
    }
    else { setDashboard(false); setPopup(true); }
  };
  useEffect( () => {
    if(!localStorage.getItem('session')){
      setDashboard(false);
      setPopup(true);
    }
    if(dashboard === true) {
      setUser(null)
      getUserInformation();

      const interval = setInterval(() => {
        getUserInformation();
      }, 5000);
      return () => clearInterval(interval); // Cleanup khi component unmount
    }
  },[dashboard]);

  return <>
  <Popup status={dashboard} backgroundColor={theme.backgroundHeavy}>
    <div className='max-w-xl mx-auto rounded-xl' style={{
      backgroundColor: theme.backgroundLight,
      color: theme.textColor
    }}>
      <div className='relative p-6'>
      <p className='absolute top-[10px] right-[10px] text-xs cursor-pointer' onClick={() => setDashboard(false)}>Tắt</p>
      { user && user.name && user.service ? <>
        <p className="mb-4">Xin chào {user.name}</p>
        <p className="mb-4">Phiên sử dụng của bạn còn lại <b>{user.service}</b></p>
        <p className="mb-4">Để nạp thêm phiên sử dụng AI, vui lòng chuyển khoản ngân hàng với mã QR sau</p>
        {/* 0972026280 SEVQR tinderadar */}
        <img
          className='rounded mb-4'
          src={`https://img.vietqr.io/image/vietinbank-100867822393-compact2.jpg?amount=50000&addInfo=${encodeURIComponent(user.phone)}%20SEVQR%20tinderadar&accountName=chinh%20sua%20ngu%20phap`}
          alt="QR code"
        />
      </> : <><Skeleton/><div className='h-[30px]'/></>}
        
        <Button tone="white" click={() => {
          getUserInformation()
          }}>Đã nạp tiền, check lại tài khoản</Button>
        <div className="h-[20px]"/>
        <Button click={() => {
          setUser(null)
          localStorage.removeItem("session");
          setDashboard(false);
          }}>Đăng xuất</Button>
      </div>
    </div>

    <div className='h-[30px]'/>
  </Popup>
  </>
}